import { ViewModel,View } from "binder"
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { BankSelectorViewModel } from "src/erp/arap/rawData/bank/bankSelector-viewModel";
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { ServerConnection } from "src/server/serverConnection";
import { IGateway, IPaymentInfoProvider } from "../IGateway";
import  { ChequeGatewayView } from "./chequeGateway-view"

export class ChequeGatewayViewModel extends ViewModel implements IGateway{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.title = translate("chequeGateway-viewModel.cheque",{});
    }
    
    GetDefaultView(): View <ViewModel> {
        return new ChequeGatewayView();
    }
    public getTypeId(): string {
        return "VM-986273DB-2E92-4E88-AF1E-D0184C78CB0E"
    }
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set bankSelector(v: BankSelectorViewModel) { this._bankSelector = v; } public get bankSelector(): BankSelectorViewModel { return this._bankSelector;} private _bankSelector: BankSelectorViewModel;
    public set chequeSerialNumber(v: string) { this._chequeSerialNumber = v; } public get chequeSerialNumber(): string { return this._chequeSerialNumber;} private _chequeSerialNumber: string;
    public set chequeTime(v: moment.Moment) { this._chequeTime = v; } public get chequeTime(): moment.Moment { return this._chequeTime;} private _chequeTime: moment.Moment;
    public set reason(v: string) { this._reason = v; } public get reason(): string { return this._reason;} private _reason: string;
    public set isForGuarantee(v: boolean) { this._isForGuarantee = v; } public get isForGuarantee(): boolean { return this._isForGuarantee;} private _isForGuarantee: boolean;
    public set district(v: DistrictSelector) { this._district = v; } public get district(): DistrictSelector { return this._district;} private _district: DistrictSelector;
    
    
    initialLoad(): void {
        this.district = new DistrictSelector(this);
        this.bankSelector = new BankSelectorViewModel(this);
    }
    async save(dataProvider: IPaymentInfoProvider): Promise<any> {
        let paymentInfo = dataProvider.getBasePaymentInfoDto();
        return await ServerConnection.callServer('Complex/PaymentProcessServices/CreateChequeTransferPayment',{
            ProcessId:paymentInfo.processId,
            Attachments:paymentInfo.attachments.map(p=>{
                return{
                    Data:p.content,
                    Name:p.name
                }
            }),
            BankId:this.bankSelector.selectedItem.id,
            DistrictId:this.district.selectedItem.id,
            ChequeSerialNumber:this.chequeSerialNumber,
            ChequeTime:this.chequeTime,
            Reason:this.reason,
            IsGuarantee:this.isForGuarantee
        });
    }

    validate(): string[] {
        let result = [];
        if(this.district.selectedItem==null){
            result.push("لطفا صندوق را انتخاب کنید.");  
        }
        if(this.chequeTime==null){
            result.push("لطفا تاریخ چک را انتخاب کنید.");
        }
        if(this.bankSelector.selectedItem==null){
            result.push("لطفا بانک را انتخاب کنید.");
        }
        if(stringIsNullOrEmpty(this.chequeSerialNumber)){
            result.push("لطفا سریال چک را وارد کنید.");
        }
        if(stringIsNullOrEmpty(this.reason)){
            result.push("لطفا علت (بابت) را وارد کنید.");
        }
        return result;
    }
}
